module.exports = __webpack_public_path__ + "static/media/6-Clubs.2814b0c5.svg";